/// <amd-module name="Agile/Directory/DirectoryConstants" />
export namespace DirectoryConstants {
    export const ARTIFACT_SCOPE_TYPE = "Project";
    export const LOCAL_STORAGE_KEY_PREFIX = "Directory_Group_State";
}

export namespace DirectoryFilterKeys {
    export const KEYWORD_FILTER_KEY = "Keyword";
    export const TEAM_FILTER_KEY = "Team";
}

export namespace DirectoryGroupKeys {
    export const MineGroupKey: string = "MINE";
    export const RecentGroupKey: string = "RECENT";
    export const FavoriteGroupKey: string = "FAVORITE";
    export const AllGroupKey: string = "ALL";
}

export namespace DirectoryTelemetryConstants {
    // Features
    export const DIRECTORY_DATA_INITIALIZED = "Directory_DataInitialized";
    export const DIRECTORY_ALL_DATA_INITIALIZED = "Directory_AllDataInitialized";

    export const DIRECTORY_DATA_INITIALIZE_FAILED = "Directory_DataInitialized_Failed";
    export const DIRECTORY_ALL_DATA_INITIALIZE_FAILED = "Directory_AllDataInitialized_Failed";

    export const TEAMS_COUNT = "Directory_TeamsCount";
    export const FAVORITE_COUNT = "Directory_FavoriteCount";
}
